/* eslint-disable import/prefer-default-export */
export const SET_USER = 'SET_USER';
export const SET_PROFILE = 'SET_PROFILE';
export const SET_PRIZES_CODES = 'SET_PRIZES_CODES';
